import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { getInviteByShortId, recordResponse } from '../../services/inviteService';
import { templates, defaultPattern, getPatternStyle } from './templates';
import './styles/pages.css';
import './styles/templates.css';

const InviteView = () => {
  const { shortId } = useParams();
  const navigate = useNavigate();

  const [invite, setInvite] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showCta, setShowCta] = useState(false);

  useEffect(() => {
    const fetchInvite = async () => {
      console.log('Fetching invite with shortId:', shortId);
      try {
        const data = await getInviteByShortId(shortId);
        console.log('Fetched invite data:', data);
        if (data) {
          setInvite(data);
        }
      } catch (error) {
        console.error('Error fetching invite:', error);
      }
      setLoading(false);
    };

    fetchInvite();
  }, [shortId]);

  const handleYes = async () => {
    setShowCta(true);
    try {
      await recordResponse(shortId, 'yes');
    } catch (error) {
      console.error('Error recording response:', error);
    }
  };

  if (loading) {
    return (
      <div className="loading-page">
        <motion.div
          className="loading-heart"
          animate={{ scale: [1, 1.2, 1] }}
          transition={{ duration: 0.8, repeat: Infinity }}
        >
          {'\uD83D\uDC8C'}
        </motion.div>
        <p>Loading your special invite...</p>
      </div>
    );
  }

  if (!invite) {
    return (
      <div className="error-page">
        <h1>{'\uD83D\uDE22'} Invite Not Found</h1>
        <p>This invite may have expired or doesn't exist.</p>
        <button onClick={() => navigate('/Playground/Inviteapp')}>
          Create Your Own Invite {'\uD83D\uDC8C'}
        </button>
      </div>
    );
  }

  const template = templates[invite.templateId];
  if (!template) {
    return (
      <div className="error-page">
        <h1>Template Error</h1>
        <p>Something went wrong loading this invite.</p>
      </div>
    );
  }

  const TemplateComponent = template.component;
  const patternStyle = getPatternStyle(invite.pattern || defaultPattern, template.colors.primary);

  return (
    <div className="invite-view-page">
      <TemplateComponent
        question={invite.question}
        cta={invite.cta}
        onYes={handleYes}
        showCta={showCta}
        patternStyle={patternStyle}
      />

      {showCta && (
        <motion.div
          className="response-footer"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1 }}
        >
          <p>Want to send your own irresistible invite?</p>
          <button onClick={() => navigate('/Playground/Inviteapp')}>
            Create One Now {'\uD83D\uDC8C'}
          </button>
        </motion.div>
      )}
    </div>
  );
};

export default InviteView;
